import { useCallback, useState, ReactElement } from "react";

import * as CSS from "csstype";
import { Navbar as BulmaNavbar } from "react-bulma-components";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { SignOut } from "./SignOut";

import { Logo } from "components/atoms/Logo";
import { RESPONSIVE } from "helpers/responsive";

const Wrapper = styled.div<CSS.Properties>`
  &&& {
    padding: 0 1.5rem;
    .navbar-item {
      border-radius: 4px;
      height: 40px;
    }
    @media ${RESPONSIVE.DESKTOP} {
      padding: 1rem 3.5rem;
    }
    > nav {
      max-width: 960px;
      margin: 0 auto;
      min-height: 40px;
      @media ${RESPONSIVE.WIDESCREEN} {
        max-width: 1132px;
      }
      @media ${RESPONSIVE.FULL_HD} {
        max-width: 1344px;
      }
      > * {
        align-items: center;
        min-height: auto;
      }
    }
  }
`;

export function Navbar(): ReactElement | null {
  const history = useHistory();
  const path = history.location.pathname;
  const [isMenuActive, setIsMenuActive] = useState(false);

  return (
    <Wrapper>
      <BulmaNavbar active={isMenuActive}>
        <BulmaNavbar.Brand>
          <BulmaNavbar.Item renderAs="a" href="/">
            <Logo />
          </BulmaNavbar.Item>
          <BulmaNavbar.Burger
            onClick={useCallback(() => {
              setIsMenuActive(!isMenuActive);
            }, [isMenuActive])}
          />
        </BulmaNavbar.Brand>
        <BulmaNavbar.Menu>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <BulmaNavbar.Container position="end">
            <BulmaNavbar.Item href="/">通勤費・交通費</BulmaNavbar.Item>
            <BulmaNavbar.Item
              href="/routes"
              active={path === "/routes" && true}
            >
              通勤経路
            </BulmaNavbar.Item>
            <BulmaNavbar.Item href="/applications">
              承認待ち申請
            </BulmaNavbar.Item>
            <SignOut />
          </BulmaNavbar.Container>
        </BulmaNavbar.Menu>
      </BulmaNavbar>
    </Wrapper>
  );
}
